// @flow

import React, { type Node } from 'react';
import { type PlaceOrderErrorPayload } from '@tectonics/prs/outgoing-payment';
import { useSubmitError } from '@tectonics/prs/validation';

import { ErrorDisplay } from '../../molecules';
import { Empty } from '../../atoms';

export function SubmitErrorDisplay(): Node {
  const submitError = useSubmitError();

  if (!submitError) {
    return <Empty />;
  }

  return (
    <ErrorDisplay>
      <ErrorMessage error={submitError} />
    </ErrorDisplay>
  );
}

function ErrorMessage(props: { error: PlaceOrderErrorPayload }): Node {
  switch (props.error.code) {
    case 'BP-DR-18':
      return <DisabledCustomerMessage />;
    default:
      return props.error.message;
  }
}

function DisabledCustomerMessage(): Node {
  return (
    <span>
      Encontramos um problema no seu cadastro aqui no EBANX.
      Solicite suporte personalizado através da nossa <a href="https://ajuda.ebanx.com/" target="_blank" rel="noopener noreferrer">central de ajuda</a> e fale com um de nossos agentes, eles irão te ajudar a completar sua transação.
    </span>
  );
}
